export default __webpack_public_path__ + "static/media/quests.0d8d8e65.svg";